import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { devToolsAdministerPermission } from '@backstage/plugin-devtools-common';

const rootRouteRef = createRouteRef();

const uiTestPage = PageBlueprint.make({
  params: {
    path: '/ui-test',
    title: 'UI Test',
    routeRef: rootRouteRef,
    loader: () =>
      import('./BackstageUITestPage').then(m => (
        <RequirePermission permission={devToolsAdministerPermission}>
          <m.BackstageUITestPage />
        </RequirePermission>
      )),
  },
});

export const uiTestPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [uiTestPage],
});
